import Api from '../utils/Api'

export class ProductService {

    async getProducts(lazyParams,totalRecords) {

        const {first, rows, page, filters : {active, selectedCategory, selectedUnderCategory, reference, nameProduct, remise}, sortfield, sortorder } = lazyParams
        let response = {}
        const _sortfield = sortfield === null ? '_id' : sortfield
        let parameters = `totalSkip=${first}&currentPage=${page}&totalDocuments=${totalRecords}&sortfield=${_sortfield}&sortorder=${sortorder}`
        if(active != null) parameters += `&active=${active}`
        if(selectedCategory) parameters += `&category=${selectedCategory}`
        if(selectedUnderCategory) parameters += `&underCategory=${selectedUnderCategory}`
        if(reference) parameters += `&reference=${reference}`
        if(nameProduct) parameters += `&nameProduct=${nameProduct}`
        if(remise != null) parameters += `&remise=${remise}`

        try {
            console.log(`product/backoffice?${parameters}`)
            const products = await Api.get(`product/backoffice?${parameters}`)
            response.data = products.data
            return response
        } catch (error) {
            response.error =  error
            return response
        }
    }

    async getProductDetail(id) {
        let response = {}
        try {
            const products = await Api.get(`product/${id}`)
            response.data = products.data
            return response
        } catch (error) {
            console.log("error get product detail: ", error)
            response.error =  error
            return response
        }
    }

    async addProduct (data) {
        let reponse = {}
        try {
            const createdProduct = await Api.post(`product/create`,data)
            reponse.data = createdProduct.data
            return reponse
        } catch (error) {
            reponse.error = error.response.data.message
            return reponse
        }
    }

    async updatedProduct (productId,data) {
        let response = {}
        try {
            const updatedProduct = await Api.put(`product/update/${productId}`,data)
            response.data = updatedProduct.data
            return response
        } catch (error) {
            response.error = error.response.data.message
            return response
        }
    }

    async removeProduct (productId) {
        let response = {}
        try {
            const deletedProduct = await Api.delete(`product/delete/${productId}`)
            response.data = deletedProduct.data
            return response
        } catch (error) {
            response.error = error
            return response
        }
    }

    async getProductName (productTitle){
        let response = {}
        try {
            const productResponse = await Api.get(`product?active=true&nameProduct=${productTitle}`)
            response.data = productResponse.data
            return response 
        } catch(error){
            response.error = error
            return response
        }
    }

    async syncProducts (){
        let response = {}
        try {
            const res = await Api.post(`odoo/syncProducts`)
            response.data = res.data
            return response 
        } catch(error){
            response.error = error
            return response
        }
    }

    calculDiscountPrice (originalPrice, discountPercentage){
        const discountAmount = (originalPrice * discountPercentage) / 100;
        const discountedPrice = originalPrice - discountAmount;
      
        return parseFloat(discountedPrice).toFixed(2);
    }



}